<div class="job-management" [attr.data-automation-id]="automationId + '-container'" [resBusySpinner]="isBusy"
    [message]="isBusyMessage">
    <div class="top-bar" [attr.data-automation-id]="automationId + '-header'">
        <div class="info-header" [ngStyle]="{'padding-bottom' : hasPermissions ? '5px' : ''}">
            <span>Job Management Queue</span>
            <div class="right-buttons">
                <button type="button" class="secondary-button right-align"
                    data-automation-id="job-management-update-button" (click)="update()"><i
                        class="fa fa-refresh update-button-icon"></i>Update</button>
                <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
                    (click)="openHelp()">
                    <i class="fa fa-question"></i>
                </button>
            </div>
        </div>
        <div class="left-buttons">
            <button type="button" class="primary-button" data-automation-id="job-management-apply-button"
                (click)="apply()" *ngIf="hasPermissions" [disabled]="!isApplyDiscardEnabled()">Apply</button>
            <button type="button" data-automation-id="job-management-changes-button"
                class="secondary-button discard-changes-btn" (click)="discardChanges()"
                [disabled]="!isApplyDiscardEnabled()" *ngIf="hasPermissions">Discard Changes</button>
            <button type="button" data-automation-id="job-management-cancel-selected-jobs-button"
                class="secondary-button" (click)="cancelJobs()" [disabled]="!areRowsSelected()"
                *ngIf="hasPermissions"><i class="fa fa-close"></i>Cancel
                Selected Jobs</button>
            <button type="button" data-automation-id="job-management-create-job-notification-button"
                class="secondary-button" (click)="createJobNotification()" [disabled]="!areRowsSelected()"
                *ngIf="hasPermissions"><i class="fa fa-bell-o"></i>Create Job Notification ...</button>
            <button type="button" data-automation-id="job-management-change-project-service-button"
                class="secondary-button" (click)="changePrjService()" [disabled]="!areRowsSelected()"
                *ngIf="hasPermissions"><i class="fa fa-code-fork"></i>Change Project Service ...</button>
        </div>

    </div>
    <div class="top-panel" id="topContainerId">
        <div class="grid-container" [attr.data-automation-id]="automationId + '-top-panel-details-container'">
            <res-generic-grid [gridName]="gridName" [automationId]="automationId" [columnDefs]="columnDefs"
                [rowSelection]="rowSelection" [cellClickedCallback]="cellClickedCallback"
                [contextMenuOptions]="contextMenuOptions" [requestInfo]="requestInfo"
                [responseCallback]="responseCallback" [onSelectionChanged]="onSelectionChanged"
                [gridContext]="gridContext" isGridWithDurationColumn='true' [updateStatusType]="updateStatusType"
                [rowHeight]="50" [pagerVisible]="false" [rowDragEntireRow]="true" [rowDragManaged]="true"
                [onRowDragEnd]="onRowDragEnd.bind(this)">
            </res-generic-grid>
        </div>
    </div>
    <div class="bottom-panel-info" *ngIf="!selectedJob">Select a Job to view details</div>
    <res-resizer anchor="bottom" resizingElementId="bottomContainerId" secondElementId="topContainerId" [initSize]="50"
        [usePercentages]="true" *ngIf="selectedJob" [collapsible]="true">
    </res-resizer>
    <div class="bottom-panel" *ngIf="selectedJob" [resBusySpinner]="isTaskDetailsBusy" id="bottomContainerId"
        [message]="taskDetailsBusyMessage" [attr.data-automation-id]="automationId + '-bottom-panel-details-container'">
        <div class="job-summary-container" id="jobSummary"
            [attr.data-automation-id]="automationId + '-job-summary-container'">
            <div>
                <div class="panel-header" [attr.data-automation-id]="automationId + '-job-summary-description-header'">
                    Description
                </div>
                <div class="description-area"
                    [attr.data-automation-id]="automationId + '-job-summary-description-textarea'">
                    {{selectedJob.description}}
                </div>
            </div>
            <div>
                <div class="panel-header"
                    [attr.data-automation-id]="automationId + '-job-summary-additional-info-header'">
                    Additional Information</div>
                <div class="additional-info-area">
                    <div class="modal-row">
                        <div class="modal-row-column-auto"
                            [attr.data-automation-id]="automationId + '-job-summary-additional-start-time'">Started:
                            {{selectedJob.startTime}}</div>
                    </div>
                    <div class="modal-row">
                        <div class="modal-row-column-auto"
                            [attr.data-automation-id]="automationId + '-job-summary-additional-dr-service'">DR Service:
                            {{selectedJob.serviceName}}</div>
                    </div>
                    <div class="modal-row">
                        <div class="modal-row-column-auto"
                            [attr.data-automation-id]="automationId + '-job-summary-additional-nodes'">Nodes:
                            {{selectedJob.numberNodes}}</div>
                    </div>
                    <div class="modal-row">
                        <div class="modal-row-column-auto"
                            [attr.data-automation-id]="automationId + '-job-summary-additional-express-node'">Express
                            Node:
                            {{selectedJob.expressNodeCapable ? 'Capable' : 'Not capable'}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="job-details-container" [attr.data-automation-id]="automationId + '-job-details-container'">
            <div class="job-details-area">
                <div *ngFor="let task of taskList;  index as i" class="modal-fill">
                    <div class="section-heading" [attr.data-automation-id]="automationId + 'job-details-header-task'"
                        [ngStyle]="{'border-top-width': i === 0 ? '0px' : '1px'}">
                        {{ task.name }}
                    </div>
                    <table class="table">
                        <tbody>
                            <tr *ngFor="let data of task.data">
                                <td class="name" [attr.data-automation-id]="automationId + 'job-details-data-name'">
                                    {{data.name}}</td>
                                <td class="value"><span [innerHTML]="data.value"
                                        [attr.data-automation-id]="automationId + 'job-details-data-value'"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>